export default "__VITE_ASSET__DsRDka_v__"